import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  finalResults,
  getSubmissionData,
  seeAllAnswers,
  submitAnswers,
} from "../../../../Redux/test/test.action";
import { Loader } from "lucide-react";
import ToastMessage from "../../../../utils/toasts/toastMessage";
import HeaderBar from "../../../common/HeaderBar";
import DoughnutChart from "../DoughnutChart";

const FutureTestQuestions = () => {
  const nav = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const locationData = location?.state;

  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);
  const [score, setScore] = useState(0);
  const animationRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [questionsList, setQuestionsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [resultGenerated, setResultGenerated] = useState(false);
  const [timerStarted, setTimerStarted] = useState(false);

  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showWaitingPage, setShowWaitingPage] = useState(false);

  const [resultList, setResultList] = useState(null);

  const [showEvaluatioModal, setShowEvaluationModal] = useState(false);

  const [questionStatuses, setQuestionStatuses] = useState([]);
  const [statusesInitialized, setStatusesInitialized] = useState(false);
  const [toastState, setToastState] = useState({
    show: false,
    message: "",
    type: "",
  });

  const collapseAreaRef = useRef(null);

  useEffect(() => {
    if (!locationData) return;

    const getData = locationData[0];
    setData(getData);
    setTimerStarted(true);

    setQuestionsList(getData?.assignment_data);

    const start = new Date(getData.start_time).getTime();
    const end = new Date(getData.end_time).getTime();

    const totalDuration = end - start;

    const elapsed = Date.now() - start;

    let remaining = Math.max(0, totalDuration - elapsed);

    setTimeLeft(remaining);

    const interval = setInterval(() => {
      remaining -= 1000;

      if (remaining <= 0) {
        remaining = 0;
        clearInterval(interval);
      }

      setTimeLeft(remaining);
    }, 1000);

    return () => clearInterval(interval);
  }, [locationData]);

  const hh = String(Math.floor(timeLeft / 3600000)).padStart(2, "0");
  const mm = String(Math.floor((timeLeft % 3600000) / 60000)).padStart(2, "0");
  const ss = String(Math.floor((timeLeft % 60000) / 1000)).padStart(2, "0");

  // Pomodoro ring progress (0 = full ring, 1 = empty)
  const totalDuration = data
    ? new Date(data.end_time).getTime() - new Date(data.start_time).getTime()
    : 1;
  const timerProgress =
    totalDuration > 0
      ? Math.max(0, Math.min(1, 1 - timeLeft / totalDuration))
      : 0;
  const isLowTime = timeLeft !== null && timeLeft < 60000 && timeLeft > 0;
  const CIRCUMFERENCE = 2 * Math.PI * 90;

  // const testStoreQuestionList =
  //   data?.questionsList?.questions || data?.assignment_data;
  // const assiginmentID = data?.submission_id;
  // const totalQues = data?.questionsList?.total_questions
  //   ? data?.questionsList?.total_questions
  //   : data?.total_questions;
  // const context = data?.questionsList?.context;

  const handleOptionChange = (questionId, selectedOption) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: selectedOption,
    }));
    setQuestionStatuses((prev) =>
      prev.map((q) => (q.id === questionId ? { ...q, status: "answered" } : q)),
    );
  };

  const allQuestions = [
    ...(questionsList?.mcq || []),
    ...(questionsList?.short_answer || []),
    ...(questionsList?.fill_in_the_blank || []),
  ];
  const totalQuestions = allQuestions.length;

  // Initialize questionStatuses once when allQuestions becomes available
  useEffect(() => {
    if (totalQuestions > 0 && !statusesInitialized) {
      setQuestionStatuses(
        Array.from({ length: totalQuestions }, (_, i) => ({ id: i + 1, status: "" }))
      );
      setStatusesInitialized(true);
    }
  }, [totalQuestions, statusesInitialized]);
  const handleNext = (e) => {
    e.preventDefault();

    if (currentIndex < totalQuestions - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      handleGenerateResult();
    }
  };

  // 1. Use a ref to prevent duplicate calls
  const hasSubmitted = useRef(false);

  // 2. Guard the useEffect so it only fires ONCE when timeLeft hits 0
  useEffect(() => {
    if (timeLeft === 0 && !hasSubmitted.current) {
      hasSubmitted.current = true;
      setShowWaitingPage(true);
      handleGenerateResult();
    }
  }, [timeLeft]);

  const handleConfirmSubmit = () => {
    setShowConfirmModal(false);

    if (timeLeft > 0) {
      setShowWaitingPage(true);
    } else {
      if (!hasSubmitted.current) {
        hasSubmitted.current = true;
        handleGenerateResult();
      }
    }
  };

  // const handleGenerateResult = async () => {
  //   setLoading(true);

  //   if (!questionsList) {
  //     setToastState({
  //       show: true,
  //       message: "Error on generating results",
  //       type: "error",
  //     });
  //     setLoading(false);
  //     return;
  //   }

  //   const id = data?.assignment_id;
  //   const payload = { answers: selectedAnswers };

  //   const result = await dispatch(submitAnswers(payload, id));

  //   if (result?.success === true) {
  //     await handleGenerateAnswers(); // await it so loading state stays consistent
  //   } else {
  //     setLoading(false);
  //   }
  // };

  // const handleGenerateAnswers = async () => {
  //   const id = data?.assignment_id;

  //   try {
  //     setLoading(true);
  //     const result = await dispatch(seeAllAnswers(id));
  //     const message = result?.data?.message;
  //     setScore(result?.data?.percentage_obtained);

  //     if (result?.success && message?.includes("Evaluation in progress")) {
  //       setShowEvaluationModal(true);
  //       setLoading(false);

  //       // 3. Use a cleaner retry with cleanup
  //       setTimeout(() => {
  //         handleGenerateAnswers();
  //       }, 10000);
  //     } else if (
  //       result?.success &&
  //       message?.includes("Here are your results")
  //     ) {
  //       setLoading(false);
  //       setShowEvaluationModal(false);
  //       setResultList(result?.data);
  //       setShowModal(true);
  //     } else {
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     setLoading(false);
  //     setToastState({
  //       show: true,
  //       message: "Something went wrong.",
  //       type: "error",
  //     });
  //   }
  // };

  // const handleSeeAnswers = () => {
  //   nav("/show-answers", { state: resultList ? resultList : null });
  // };

  const pollTimeoutRef = useRef(null);

useEffect(() => {
  // Cleanup: cancel any pending poll if component unmounts
  return () => {
    if (pollTimeoutRef.current) {
      clearTimeout(pollTimeoutRef.current);
    }
  };
}, []);

const handleGenerateResult = async () => {
  setLoading(true);

  if (!questionsList) {
    setToastState({
      show: true,
      message: "Error on generating results",
      type: "error",
    });
    setLoading(false);
    return;
  }

  const id = data?.assignment_id;
  const payload = { answers: selectedAnswers };

  const result = await dispatch(submitAnswers(payload, id));

  if (result?.success === true) {
    await handleGenerateAnswers(); // await it so loading state stays consistent
  } else {
    setLoading(false);
    setToastState({
      show: true,
      message: result?.response || "Failed to submit answers. Please try again.",
      type: "error",
    });
  }
};

const handleGenerateAnswers = async () => {
  const id = data?.assignment_id;

  setLoading(true);
  const result = await dispatch(seeAllAnswers(id));

  if (!result?.success) {
    setLoading(false);
    setToastState({
      show: true,
      message: "Something went wrong while fetching your results.",
      type: "error",
    });
    return;
  }

  const message = result?.data?.message;
  setScore(result?.data?.percentage_obtained);

  if (message?.includes("Evaluation in progress")) {
    setShowEvaluationModal(true);
    setLoading(false);

    pollTimeoutRef.current = setTimeout(() => {
      handleGenerateAnswers();
    }, 10000);
  } else if (message?.includes("Here are your results")) {
    setLoading(false);
    setShowEvaluationModal(false);
    setResultList(result?.data);
    setShowModal(true);
  } else {
    setLoading(false);
  }
};

const handleSeeAnswers = () => {
  nav("/show-answers", { state: resultList ? resultList : null });
};

  const handleSkip = () => {
    const currentQuestionId = currentIndex + 1;
    // Set status to 'skipped' only if not already answered
    setQuestionStatuses((prev) =>
      prev.map((q) => (q.id === currentQuestionId && q.status !== "answered" ? { ...q, status: "skipped" } : q))
    );
    if (currentIndex < totalQuestions - 1) {
      setCurrentIndex((prev) => prev + 1);
    } else {
      // setShowModal(true);
    }
  };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex((prev) => prev - 1);
    }
  };

  const renderQuestion = () => {
    const question = allQuestions[currentIndex];
    const currentQuestionId = currentIndex + 1;
    const selected = selectedAnswers[currentQuestionId];
    if (question?.options) {
      return (
        <div className="mb-4">
          <h4 className="fw600 fz22 mb-3">{question?.question}</h4>
          <ul className="list-inline mcqs">
            {question?.options?.map((opt, idx) => {
              const optionId = `mcq-option-${currentIndex}-${idx}`;
              return (
                <li key={idx}>
                  <label htmlFor={optionId} className="w-100 radio-mcq">
                    <input
                      type="radio"
                      name={`mcq-${currentIndex}`}
                      id={optionId}
                      checked={selected === opt}
                      onChange={() =>
                        handleOptionChange(currentQuestionId, opt)
                      }
                    />
                    <div className="fw500 fz20">
                      {/* <span className="num">{opt.split(".")[0]}.</span>
                      <span className="ans">
                        {opt.substring(opt.indexOf(".") + 1).trim()}
                      </span> */}
                      <span className="ans">{opt}</span>
                    </div>
                  </label>
                </li>
              );
            })}
          </ul>
        </div>
      );
      // } else if (typeof question === "string") {
    } else {
      return (
        <div className="mb-4">
          <h4 className="fw600 fz22 mb-3">{question?.question}</h4>
          <input
            type="text"
            className="form-control fw500 fz20"
            placeholder="Write your answer here..."
            value={selectedAnswers[currentQuestionId] || ""}
            onChange={(e) =>
              handleOptionChange(currentQuestionId, e.target.value)
            }
          />
        </div>
      );
    }
  };

  // Close "Question Completed" collapse when user clicks outside.
  useEffect(() => {
    if (!open) return;

    const handleOutsidePointerDown = (e) => {
      if (!collapseAreaRef.current) return;
      if (collapseAreaRef.current.contains(e.target)) return;
      setOpen(false);
    };

    document.addEventListener("mousedown", handleOutsidePointerDown);
    document.addEventListener("touchstart", handleOutsidePointerDown, {
      passive: true,
    });

    return () => {
      document.removeEventListener("mousedown", handleOutsidePointerDown);
      document.removeEventListener("touchstart", handleOutsidePointerDown);
    };
  }, [open]);

  const handleModalResultClose = () => {
    setShowModal(false);
    nav("/test");
  };

  const formatTime = (ms) => {
    const totalSeconds = Math.ceil(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="overflow-hidden inner-page-content inner-page-content--test">
        <section className="test-type mx-4">
          {!showWaitingPage ? (
            <>
              <div className="main-ques">
                <div className="ff2 top-intro">
                  <div className="top-intro__left">
                    <h2 className="fz28 fw900">Give the correct answer.</h2>
                  </div>
                  <div className="top-intro__right top-intro__right--animated">
                    <p className="fw500 mb-0 fz14 grayText">Time Remaining</p>
                    <div
                      className={`animated-timer-compact${isLowTime ? " animated-timer-compact--warning" : ""}`}
                    >
                      <div className="digit-group">
                        <span className="digit-card" key={`h0-${hh[0]}`}>
                          {hh[0]}
                        </span>
                        <span className="digit-card" key={`h1-${hh[1]}`}>
                          {hh[1]}
                        </span>
                      </div>
                      <span className="timer-colon">:</span>
                      <div className="digit-group">
                        <span className="digit-card" key={`m0-${mm[0]}`}>
                          {mm[0]}
                        </span>
                        <span className="digit-card" key={`m1-${mm[1]}`}>
                          {mm[1]}
                        </span>
                      </div>
                      <span className="timer-colon">:</span>
                      <div className="digit-group">
                        <span className="digit-card" key={`s0-${ss[0]}`}>
                          {ss[0]}
                        </span>
                        <span className="digit-card" key={`s1-${ss[1]}`}>
                          {ss[1]}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="grayText mb-0 fz16">
                  {/* Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
              convallis mattis lacus at bibendum. Interdum et malesuada fames ac
              ante ipsum primis in faucibus.{" "} */}
                </p>
              </div>
              <div className="QnA-block">
                <div className="QnA-block__top">
                  <div className="left-gray">
                    <h6 className="fz18 fw500">
                      Question {currentIndex + 1} of {totalQuestions}
                    </h6>
                    <h2 className="fz28 fw900">
                      {questionsList[currentIndex]?.title}
                    </h2>
                  </div>
                  <div className="right-dark" ref={collapseAreaRef}>
                    <div className="text-white info">
                      <span className="fw500 fz16">Question Completed</span>
                      <Button
                        className="btn-collapse"
                        onClick={() => setOpen(!open)}
                        aria-controls="example-collapse-text"
                        aria-expanded={open}
                      >
                        <img
                          src="./assets/images/inner-pages/icons/icon-collapse--down.svg"
                          alt=""
                        />
                      </Button>
                      <span className="fz20 fw700 ms-auto">
                        {currentIndex + 1}/{totalQuestions}
                      </span>
                    </div>
                    <div className="answer-progress">
                      <div
                        className="progress-bar"
                        style={{
                          width: `${((currentIndex + 1) / totalQuestions) * 100}%`,
                        }}
                      />
                    </div>
                    <Collapse in={open}>
                      <div id="example-collapse-text">
                        <div className="ques-pages">
                          <ul className="list-inline">
                            {questionStatuses.map((question, index) => (
                              <li key={question.id}>
                                <a
                                  href="javascript:;"
                                  className={`btn btn-round btn-roun--dark ${
                                    question.status === "skipped" ? "skipped" : question.status
                                  } ${currentIndex === index ? "active" : ""}`}
                                  onClick={() => setCurrentIndex(index)}
                                >
                                  {question.id}
                                </a>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </Collapse>
                  </div>
                </div>
                <div className="QnA-block__bottom">
                  {renderQuestion()}
                  <div className="group-btns d-flex gap-2">
                    {currentIndex > 0 && (
                      <button
                        className="fw500 fz20 btn btn-outlined btn-outlined--dark"
                        onClick={handleBack}
                      >
                        Back
                      </button>
                    )}
                    {currentIndex < totalQuestions - 1 && (
                      <button
                        className="fw500 fz20 btn btn-outlined btn-outlined--dark"
                        onClick={handleSkip}
                      >
                        Skip
                      </button>
                    )}
                    {/* <button
                  className="fw500 fz20 btn btn-solid btn-solid--dark"
                  onClick={(e) => handleNext(e)}
                >
                  {currentIndex === totalQuestions - 1 ? "Finish" : "Next"}
                </button> */}
                    <button
                      className="fw500 fz20 btn btn-solid btn-solid--dark"
                      onClick={(e) => {
                        if (currentIndex === totalQuestions - 1) {
                          setShowConfirmModal(true);
                        } else {
                          handleNext(e);
                        }
                      }}
                    >
                      {currentIndex === totalQuestions - 1 ? "Finish" : "Next"}
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : showEvaluatioModal ? (
            <div className="waiting-page-premium">
              <div className="evaluation-card border-0 shadow-lg p-5">

                {/* Animated Decorative Top Line */}
                <div className="card-accent-line"></div>

                <div className="video-animation-wrapper">
                  <video
                    autoPlay
                    loop
                    muted
                    playsInline // Required for iOS autoPlay
                    className="premium-eval-video"
                    onError={(e) => {
                      console.error("Video Error:", e);
                    }}
                  >
                    <source
                      src="./assets/performance-evaluation-animation-gif-download-4074593.mp4"
                      type="video/mp4"
                    />
                    Your browser does not support the video tag.
                  </video>
                </div>

                {/* Modern Typography */}
                <div className="text-content mt-4">
                  <h3 className="eval-heading mb-2">
                    Evaluation in Progress <span className="refresh-icon">🔄</span>
                  </h3>
                  <p className="eval-subtext text-muted px-3">
                    Your answers are being evaluated carefully. This may take a few moments.
                  </p>
                </div>

                {/* Modern Animated Loader */}
                <div className="modern-pulse-loader mt-4">
                  <div className="pulse-dot"></div>
                  <div className="pulse-dot"></div>
                  <div className="pulse-dot"></div>
                </div>
              </div>
            </div>
          ) : (
            <div className="waiting-page text-center">
              <div className="waiting-page__card">
                <div className="waiting-page__icon">⏳</div>
                <h3 className="waiting-page__title">Test Submitted</h3>

                <div className="animated-timer-large">
                  <div className="timer-ring-container">
                    {/* SVG Ring - Unchanged Original UI */}
                    <svg className="timer-ring" viewBox="0 0 200 200">
                      <defs>
                        <linearGradient id="timerGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                          <stop offset="0%" stopColor="#67e8f9" />
                          <stop offset="100%" stopColor="#a78bfa" />
                        </linearGradient>
                      </defs>
                      <circle className="timer-ring__bg" cx="100" cy="100" r="90" />
                      <circle
                        className="timer-ring__glow"
                        cx="100" cy="100" r="90"
                        style={{
                          strokeDasharray: CIRCUMFERENCE,
                          strokeDashoffset: CIRCUMFERENCE * timerProgress,
                        }}
                      />
                      <circle
                        className="timer-ring__progress"
                        cx="100" cy="100" r="90"
                        style={{
                          strokeDasharray: CIRCUMFERENCE,
                          strokeDashoffset: CIRCUMFERENCE * timerProgress,
                        }}
                      />
                    </svg>

                    {/* Linear Premium Digit Display */}
                    <div className="timer-ring__digits-linear">
                      {/* Hours Section */}
                      <div className="digit-segment">
                        <div className="digit-cards-row">
                          <span className="digit-card-v2">{hh[0]}</span>
                          <span className="digit-card-v2">{hh[1]}</span>
                        </div>
                        <span className="digit-label-v2">HRS</span>
                      </div>

                      <span className="timer-separator">:</span>

                      {/* Minutes Section */}
                      <div className="digit-segment">
                        <div className="digit-cards-row">
                          <span className="digit-card-v2">{mm[0]}</span>
                          <span className="digit-card-v2">{mm[1]}</span>
                        </div>
                        <span className="digit-label-v2">MIN</span>
                      </div>

                      <span className="timer-separator">:</span>

                      {/* Seconds Section */}
                      <div className="digit-segment">
                        <div className="digit-cards-row">
                          <span className="digit-card-v2">{ss[0]}</span>
                          <span className="digit-card-v2">{ss[1]}</span>
                        </div>
                        <span className="digit-label-v2">SEC</span>
                      </div>
                    </div>
                  </div>
                </div>

                <h4 className="waiting-page__wait-text">
                  Please wait until the time is over.
                </h4>
              </div>
            </div>
          )}
        </section>

        {showModal && (
          <div
            className="modal fade show"
            id="resultModal"
            tabIndex={-1}
            aria-labelledby="resultModalLabel"
            aria-hidden="true"
            style={{ display: "block", background: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="border-0 bdrs40 modal-content">
                <div className="w-100 result-content">
                  <button
                    type="button"
                    className="rounded-circle ts03 btn-close"
                    onClick={handleModalResultClose}
                  />
                  <div className="w-100 success-chart">
                    <DoughnutChart
                      elementId="resultDonut"
                      // color="#000"
                      color="green"
                      dataValue={score ? score : 0}
                      graphBorder="70%"
                      modalId="resultModal"
                    />
                    <div className="inner-num">
                      <div className="fw700 fz44">{score}%</div>
                      <p className="fz16 mb-0">Final Score</p>
                    </div>
                  </div>
                  <h4 className="fz28 fw500 lh1">Test Result</h4>
                  <button
                    className="w-100 btn btn-solid btn-solid--dark fz18"
                    onClick={handleSeeAnswers}
                  >
                    See Your Answers
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {showConfirmModal && (
          <div
            className="modal fade show"
            style={{
              display: "block",
              backgroundColor: "rgba(15, 23, 42, 0.7)",
              backdropFilter: "blur(12px)", /* Premium blur effect */
              zIndex: 1050
            }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bdr-24 border-0 p-2 overflow-hidden shadow-lg">

                {/* Subtle Background Decoration */}
                <div className="modal-accent-gradient"></div>

                <div className="modal-body p-5 text-center position-relative">
                  <button
                    type="button"
                    className="btn-close-custom-top"
                    onClick={() => setShowConfirmModal(false)}
                  >
                    &times;
                  </button>

                  {/* 1. Animated Success/Alert Icon */}
                  <div className="modal-icon-container mb-4">
                    <div className="icon-pulse-effect"></div>
                    <div className="icon-circle-main">
                      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                        <polyline points="22 4 12 14.01 9 11.01"></polyline>
                      </svg>
                    </div>
                  </div>

                  {/* 2. Typography Upgrade */}
                  <h3 className="fw700 mb-2 color-dark-navy">Final Submission</h3>
                  <p className="text-muted mb-4 fs-15 px-3">
                    Are you ready to wrap up? Once submitted, your answers will be locked and cannot be edited.
                  </p>

                  {/* 3. High-End Button Actions */}
                  <div className="d-flex justify-content-center gap-3 mt-2">
                    <button
                      className="btn-minimal-cancel"
                      onClick={() => setShowConfirmModal(false)}
                    >
                      Go Back
                    </button>
                    <button
                      className="btn-premium-submit"
                      onClick={handleConfirmSubmit}
                    >
                      Submit Test
                      <svg className="ms-2" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* <Loader show={loading} /> */}
        <ToastMessage
          show={toastState.show}
          onClose={() => setToastState({ show: false, message: "", type: "" })}
          message={toastState.message}
          type={toastState.type}
        />
      </div>
    </main>
  );
};
export default FutureTestQuestions;
